import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function listEvents(params = {}) {
  const { data } = await axios.get(`${API}/events`, { params });
  return data.events;
}
export async function getEvent(id) {
  const { data } = await axios.get(`${API}/events/${id}`);
  return data;
}
export async function createEvent(payload) {
  const { data } = await axios.post(`${API}/events`, payload, { withCredentials: true });
  return data;
}
export async function getUserProfile(userId) {
  const { data } = await axios.get(`${API}/users/${userId}`);
  return data;
}
export async function updateMyProfile(patch) {
  const { data } = await axios.patch(`${API}/auth/me`, patch, { withCredentials: true });
  return data;
}
